export default [
    {
        name: 'userActivityPostDetailPage-comments',
        path: 'comments',
        component: () => import(/* webpackChunkName: "activityPost" */ './UserActivityPostDetailPageComments'),
        props: true,
        meta: { name: 'comments' },
    },
    {
        name: 'userActivityPostDetailPage-info',
        path: '',
        component: () => import(/* webpackChunkName: "activityPost" */ './UserActivityPostDetailPageInfo'),
        props: true,
        meta: { name: 'info' },
    },
];
